import React from 'react';
import { createStyles, Theme, makeStyles } from '@material-ui/core/styles';
import { Box, AppBar, Container, Toolbar, Typography, Tab, Tabs, IconButton, Snackbar, Fab, Dialog, DialogContent, DialogTitle, DialogActions, Button} from '@material-ui/core'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Link, RouteProps  } from "react-router-dom";
import './App.css';
import Introduction from './pages/Introduction';
import { AccountCircle, PlaylistAddCheckOutlined } from '@material-ui/icons';
import authStore from './stores/authStore';
import { observer } from 'mobx-react-lite';
import Login from './pages/Login';
import Profile from './pages/Profile';
import About from './pages/About';
import Dashboard from './pages/Dashboard';
import Terms from './pages/Terms';

//import logo from './resources/csiro-white-logo.550c139b.svg';

interface Props extends RouteProps {
    component: any;
  }
const ProtectedRoute: React.FC<Props> = ({ component: Component, ...rest }) => <Route {...rest} render={(props)=>  authStore.authorized === true ? <Component /> : <Redirect to='/login' /> } />


const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
        display: 'flex'
    },
    appBar: {
        zIndex: theme.zIndex.drawer + 1,
    },
    margin: {
      margin: theme.spacing(1),
      color: 'white'
    },
    extendedIcon: {
      marginRight: theme.spacing(1),
    },
    fullHeight: {
        ...theme.mixins.toolbar,
      },
    speedDial: {
        position: 'fixed',
        bottom: theme.spacing(2),
        right: theme.spacing(2),
      },
  }),
);

function App() {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const handleClose = () => {
        setOpen(false);
      };
    
      const handleOpen = () => {
        setOpen(true);
      };
    return (
        <div>
            <AppBar position="fixed" className={classes.appBar}  >
                <Container>
                <Toolbar>
                    <img src={"https://looc-c.farm/static/media/csiro-white-logo.550c139b.svg"} height="40rem" width="40rem" className={classes.extendedIcon}/>
                    <Typography variant="h6" component="div">
                        LOOC-B
                    </Typography>
                    <Box sx={{ flexGrow: 1 }} />

                    <Route path="/"
                    render={(history) => (
                        <Tabs
                            classes={{ root: classes.fullHeight }}
                            value={
                            history.location.pathname !== "/"
                                ? history.location.pathname
                                : '/introduction'
                            }
                    >
                        <Tab
                            classes={{ root: classes.fullHeight }}
                            value='/introduction'
                            label="Introduction"
                            component={Link}
                            to='introduction'
                        />
                        <Tab
                            classes={{ root: classes.fullHeight }}
                            value='/estimate'
                            label="Estimate"
                            component={Link}
                            to='estimate'
                        />
                        <Tab
                            classes={{ root: classes.fullHeight }}
                            value='/about'
                            label="About"
                            component={Link}
                            to='about'
                        />
                    </Tabs>
                    )}
                >
                </Route>
                    <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
                        <IconButton to="/profile" component={Link} color="inherit">
                            <AccountCircle />
                        </IconButton>
                    </Box>
                </Toolbar>
                </Container>
            </AppBar>

            <Switch>
                <Route exact path='/' component={Introduction} />
                <Route exact path='/about' component={About} />
                <Route exact path='/estimate' component={Dashboard} />
                <Route exact path='/introduction' component={Introduction} />
                <ProtectedRoute path='/profile' component={Profile} />
                <Route exact path='/login' component={Login} />
                <Route exact path='/terms' component={Terms} />
            </Switch>
            <Dialog open={open}>
                <DialogTitle>This is a prototype. Help us make it better</DialogTitle>
                <DialogContent>
                    <li>Report a bug or something that doesn't seem right, click this <a target="blank" href="https://www.surveymonkey.com/r/S3BV72D">link</a></li>
                    <li>Feedback about your registration experience and using the web based interface, click this <a target="blank" href="https://www.surveymonkey.com/r/WV7V7GS">link</a></li>
                    <li>Feedback about your registration experience and using the API, click this <a target="blank" href="https://www.surveymonkey.com/r/S3YM7RS">link</a></li>
                </DialogContent>
                <DialogActions>
                    <Button variant='contained' color="primary" onClick={handleClose}>Close</Button>
                </DialogActions>
            </Dialog>
            {/* <Fab color="primary" variant="extended" className={classes.speedDial} onClick={handleOpen}>
                <PlaylistAddCheckOutlined className={classes.extendedIcon}/>
                Survey
            </Fab> */}
            {/* <Container style={{ textAlign: 'center' }}>
                <Grid item xs={12}>
                    © {new Date().getFullYear()} Example project | All Rights Reserved.
                </Grid >
            </Container> */}

        </div>
    );
}

export default observer(App);
